const LightTheme = {
    primaryBackground: '#fff',
    secondaryBackground: '#e4e4e4',
    primaryText: '#000',
    secondaryText: '#757575',
};

const DarkTheme = {
    primaryBackground: '#000',
    secondaryBackground: '#2F2F2F',
    primaryText: '#fff',
    secondaryText: '#a5a5a5',
};

export const themes = {
    light: LightTheme,
    dark: DarkTheme,
};